import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AddCustomerEntity, Customer, CustomerAddress } from 'app/layout/customer/customer.models';
import { CustomerService } from 'app/layout/customer/customer.service';
import { SelectItem } from 'primeng/api';
import { BaseComponent } from '../base.component';
import { compareValidator, emailValidator, latValidator, lonValidator } from '../custom-validators/custom-validator.directive';
import { Operator, Type } from '../custom-validators/custom-validator.model';
import { LoaderService } from '../loader.service';
import { CapitalizeFirstPipe } from '../pipes/custom-pipes.pipe';
import { Severities } from '../shared.model';
import { SharedService } from '../shared.service';

@Component({
  selector: 'app-add-site',
  templateUrl: './add-site.component.html',
  providers: [CustomerService]
})
export class AddSiteComponent extends BaseComponent implements OnInit {
  @Output() close = new EventEmitter();
  @Output() done = new EventEmitter();
  isAddCustomer: boolean = false;
  frmCustomer: FormGroup;
  frmAddress: FormGroup;
  IsNetworkCustomer: boolean = false;
  headerCustomerIDCLLI: string;
  headerCustomerNameNetworkName: string;
  customerType: any[] = [];
  isPasswordComplexityPopup: boolean = false;
  complexval: string[] = [];
  passwordcomplexity: string[] = [];
  ispasswordcomplex: boolean = false;
  selectItem: SelectItem[] = [];
  preferredContact: any[] = [];
  isLatLon: boolean = false;
  cLLICodeIsRequied: boolean = false;
  constructor(protected translateService: TranslateService,
    protected sharedService: SharedService, private _fb: FormBuilder,
    private loaderService: LoaderService, private customerService: CustomerService) {
    super(sharedService, translateService)
    this.isLatLon = this.globalInfo().IsLatLonBased;
  }
  ngOnInit() {
    this.frmCustomerInialize();
    this.frmAddressInialize();
    this.headerNameChangeforNetwork();
    this.getCustomerTypes();
    this.getPreferredContact();
    this.loadDropdown();
    this.getCustomerStatus();
  }

  frmCustomerInialize() {
    this.frmCustomer = this._fb.group({
      CustomerTypeId: ['0', Validators.required],
      CustomerName: ['', Validators.required],
      TitleId: ['0', Validators.required],
      PrefContactMode: [],//Prefered contact
      Email: ['', emailValidator],
      Password: ['', Validators.compose([compareValidator('Confpassword', Type.string, Operator.Equal, null, true)])],
      Confpassword: ['', Validators.compose([compareValidator('Password', Type.string, Operator.Equal)])],
      Phone1: [''],
      Phone2: '',
      Fax: '',
      CustomerStatusId: [0],
      ClliCode: '',
      NetworkNo: '',
      NetworkType: '',
      Node: ''
    },
      {
        validator: Validators.compose([onblurchange(), validateEmailRequired()])
      }
    );
  }

  frmAddressInialize() {
    if (this.isLatLon) {
      this.frmAddress = this._fb.group({
        AddressTypeId: [1],
        AddressName: ['', Validators.required],
        AddressLine1: [''],
        AddressLine2: [''],
        UnitNo: [''],
        CreatedDate: [null],
        CreatedBy: [0],
        CountryId: [this.globalInfo().DefaultCountryId],
        CountryName: ['', []],
        UserLat: ['', latValidator],
        UserLon: ['', lonValidator],
        CustomerAddressId: [0],
        billlookup: [''],
        copyBill: [''],
        RegionId: [0, Validators.required],
        IsActive: [1],
        IsPrimary: [1],
        CopyAddress: [0],
        CopyBillingAccount: [0]
      });
    }
    else {
      this.frmAddress = this._fb.group({
        AddressTypeId: [1],
        AddressName: ['', Validators.required],
        AddressLine1: ['', Validators.required],
        AddressLine2: [''],
        UnitNo: [''],
        CityName: ['', Validators.required],
        CreatedDate: [null],
        CreatedBy: [0],
        StateName: [''],
        StateId: [0],
        ZipCode: ['', Validators.required],
        CountryId: [this.globalInfo().DefaultCountryId],
        CountryName: ['', []],
        StateShortName: ['', Validators.required],
        CustomerAddressId: [0],
        billlookup: [''],
        copyBill: [''],
        IsActive: [1],
        IsPrimary: [1],
        CopyAddress: [0],
        CopyBillingAccount: [0]
      });
    }
  }

  getCustomerStatus() {
    this.customerService.getCustomerStatus(super.globalInfo().CompanyId).subscribe(res => {
      if (res && res.length > 0)
        this.frmCustomer.controls['CustomerStatusId'].setValue(res[0].CustomerStatusId);
    });
  }

  headerNameChangeforNetwork() {
    if (this.IsNetworkCustomer) {
      this.headerCustomerIDCLLI = this.translateService.instant('CLLICODE');
      this.headerCustomerNameNetworkName = this.translateService.instant('NETWORKNAME');
      this.frmCustomer.get('Phone1').setValidators([]);
      this.frmCustomer.get('Phone1').updateValueAndValidity();
    }
    else {
      this.headerCustomerIDCLLI = this.translateService.instant('CUSTOMERID');
      this.headerCustomerNameNetworkName = this.translateService.instant('CUSTOMERNAME');
      this.frmCustomer.get('Phone1').setValidators([Validators.required]);
      this.frmCustomer.get('Phone1').updateValueAndValidity();
    }
  }
  getCustomerTypes() {
    this.sharedService.getCustomerTypes(super.globalInfo().CompanyId).subscribe(res => {
      this.customerType = res;
      this.IsNetworkCustomer = this.customerType.find(s => s.IsNetwork == 0) ? false : true;
    });
  }

  onChangeCustomerType() {
    let selectedCustomerType: number = +this.frmCustomer.value.CustomerTypeId;
    if (selectedCustomerType > 0) {
      let cusType = this.customerType.find(f => f.CustomerTypeId == selectedCustomerType);
      if (cusType)
        this.IsNetworkCustomer = (cusType.IsNetwork == 1);
    }
    this.headerNameChangeforNetwork();
  }

  getPreferredContact() {
    this.customerService.getPreferredContact(super.globalInfo().CompanyId, 9).subscribe(res => {
      this.preferredContact = res;
      if (this.preferredContact) {
        for (var i = 0; i <= this.preferredContact.length - 1; i++) {
          this.selectItem.push({ label: this.preferredContact[i].Description, value: this.preferredContact[i].ConfigDtlId });
        }
      }
    });
  }
  submitted: boolean = false;
  loader: boolean = false;
  customerData: Customer;
  addressData: CustomerAddress;
  addCustomer() {
    debugger;
    this.customerData = new Customer();
    this.addressData = new CustomerAddress();
    let c = this.saveCustomer();
    let a = this.saveAddress();
    this.submitted = true;
    if (c && a) {
      this.loader = true;
      let input: AddCustomerEntity = {
        AddressEntity: this.addressData,
        CustomerEntity: this.customerData
      }
      this.customerService.AddCustomerAndAddress(input).subscribe(
        s => {
          this.loader = false;
          if (s.Message) {
            if (s.Message.MessageCode == "1001" || s.Message.MessageCode == "1004") {
              this.sharedService.notification.emit({
                severity: Severities[s.Message.Severity],
                summary: CapitalizeFirstPipe.prototype.transform(Severities[s.Message.Severity]),
                detail: this.translate.instant('CUSTOMER') + " " + this.translate.instant(s.Message.MessageCode)
              });
              this.done.emit(s.Data);
            }
            else {
              this.sharedService.notification.emit({
                severity: Severities[s.Message.Severity],
                summary: CapitalizeFirstPipe.prototype.transform(Severities[s.Message.Severity]),
                detail: this.translate.instant(s.Message.MessageCode)
              });
            }
          }
          else {
            this.sharedService.notification.emit({
              severity: Severities[3],
              summary: CapitalizeFirstPipe.prototype.transform(Severities[3]),
              detail: this.translate.instant('10000')
            });
          }
        },
        e => {
          this.loader = false;
          this.sharedService.notification.emit({
            severity: Severities[3],
            summary: CapitalizeFirstPipe.prototype.transform(Severities[3]),
            detail: this.translate.instant('10000')
          });
        }
      );
    }
  }

  saveCustomer(): boolean {
    let customer: Customer = this.frmCustomer.value;
    this.validateCLLICode(customer.ClliCode);
    this.submitted = true;
    if (this.frmCustomer.valid) {
      if (customer.CustomerTypeId == 0) return false;      
      customer.CustomerName.trim();
      customer.CompanyId = super.globalInfo().CompanyId;
      customer.CreatedBy = super.globalInfo().LoginId;
      customer.CreatedSourceId = 1;
      customer.IsCustomerTypeHoliday = 1;
      customer.IsNetwork = this.IsNetworkCustomer ? 1 : 0;
      this.customerData = customer;
      return true;
    }
    return false;
  }

  saveAddress(): boolean {
    let customerAddress: CustomerAddress = this.frmAddress.value;
    if (customerAddress.CountryId == 0) return false;
    if (this.isLatLon) {
      if (customerAddress.RegionId == 0) return false;
    }
    if (this.frmAddress.valid) {      
      customerAddress.AddressName.trim()
      customerAddress.CompanyId = this.globalInfo().CompanyId;
      customerAddress.IsActive = 1;
      customerAddress.IsPrimary = 1;
      customerAddress.CreatedDate = new Date().toDateString();
      customerAddress.LastUpdate = new Date().toDateString();
      customerAddress.CreatedBy = this.globalInfo().LoginId;
      customerAddress.LastChangedBy = this.globalInfo().LoginId;
      customerAddress.CompanyId = this.globalInfo().CompanyId;
      customerAddress.CustomerId = 0;
      customerAddress.CountryId = this.frmAddress.controls["CountryId"].value;
      customerAddress.CopyAddress = (customerAddress.CopyAddress) ? 1 : 0;
      customerAddress.CopyBillingAccount = this.frmAddress.controls['CopyBillingAccount'].value ? 1 : 0;
      if (customerAddress.AddressTypeId == 2 && customerAddress.CopyBillingAccount == 1)
        customerAddress.CopyAddress = 0;
      customerAddress.CustomerAddressId = 0;
      customerAddress.CreatedSourceId = 1;
      this.addressData = customerAddress;
      return true;
    }
    return false;
  }

  closePopup(event: boolean = false) {
    this.close.emit(event);
  }

  addCustomerType() {
    this.isAddCustomer = true;
  }

  closeCustomerType(event) {
    this.isAddCustomer = false;
  }

//Password related code are commented as per the issue no: 5495

  // closePassComplex() {
  //   this.isPasswordComplexityPopup = false;
  // }
  // PassComplex() {
  //   var password = this.frmCustomer.controls["Password"].value;
  //   if (password) {
  //     this.loaderService.show();
  //     this.sharedService.getPaswordComplexity(super.globalInfo().CompanyId, password).subscribe(passcomplex => {
  //       this.complexval = passcomplex;
  //       this.loaderService.hide();
  //       if (passcomplex[0] == 'True') {
  //         this.ispasswordcomplex = false;
  //       }
  //       else {
  //         this.ispasswordcomplex = true;
  //       }
  //     }, err => { this.loaderService.hide(); });
  //     onblurchange();
  //   }
  // }
  // Complexity() {
  //   this.passwordcomplexity = this.complexval;
  //   this.isPasswordComplexityPopup = true;
  // }
  
//password related code

  changeCopyAddress() {
    if (!this.frmAddress.value.CopyAddress)
      this.frmAddress.controls["CopyBillingAccount"].setValue(0);
  }
  changeCopyBillingAccount() {
    if (this.frmAddress.value.CopyBillingAccount) {
      this.frmAddress.controls["CopyAddress"].setValue(1);
    }
  }
  countryList: any[] = [];
  regionList: any[] = [];
  loadDropdown() {
    this.customerService.GetCountry(1, super.globalInfo().CompanyId).subscribe(resp => {
      this.countryList = resp;
      if (this.countryList.length > 0) {
        if (this.globalInfo().DefaultCountryId != 0) {
          this.frmAddress.patchValue(
            {
              CountryId: this.globalInfo().DefaultCountryId
            }
          );
        }
        else {
          var cid = this.countryList[0].CountryId;
          this.frmAddress.patchValue(
            {
              CountryId: cid
            }
          );
        }

      }
    });
    this.customerService.GetRegionList(this.globalInfo().CompanyId).subscribe(resp => {
      this.regionList = resp;
    });
  }
  validateCLLICode(CllICode: string) {
    if (this.IsNetworkCustomer && CllICode == '') {
      this.cLLICodeIsRequied = true;
      return false;
    }
  }

  getCustomerTypeId(CustomerTypeId: number) {
    this.isAddCustomer = false;
    this.getCustomerTypes();
    this.frmCustomer.patchValue({
      CustomerTypeId: CustomerTypeId
    })
    this.onChangeCustomerType();
  }
}
function onblurchange() {
  return (formGroup: FormGroup): { [key: string]: any } => {
    let Password = formGroup.controls['Password'];
    let Email = formGroup.controls['Email'];
    let r = ((Password.value != '') && Email.value == '') ? { 'invalidEmail': true } : null;
    return r;
  };
}
function validateEmailRequired() {
  return (formGroup: FormGroup): { [key: string]: any } => {

    let Password = formGroup.controls['Password'];
    let Email = formGroup.controls['Email'];
    let r = ((Password.value != '') && Email.value == '') ? { 'emailRequired': true } : null;
    return r;
  };
}